import * as types from './types';
const getters = {
  [types.MOBILE_TELECOMS]: state => state.mobileTelecoms,
  [types.MOBILE_CATEGORY]: state => state.mobileCategory,
  [types.MOBILE_DEVICE]: state => state.mobileDevice,
  [types.MOBILE_DEVICE_DETAIL]: state => state.mobileDeviceDetail,
  [types.MOBILE_PLAN_CATEGORY]: state => state.mobilePlanCategory,
  [types.MOBILE_PLANS]: state => state.mobilePlans,
  [types.MOBILE_PLAN_DETAIL]: state => state.mobilePlanDetail,
  [types.MOBILE_REQUEST_LIST_ING]: state => state.mobileRequestListIng,
  [types.MOBILE_REQUEST_LIST_END]: state => state.mobileRequestListEnd,
  [types.MOBILE_REQUEST_VIEW]: state => state.mobileRequestView,
  [types.MOBILE_ESTIMATE_LIST]: state => state.mobileEstimateList,
  [types.MOBILE_ESTIMATE_GROUP_LIST]: state => state.mobileEstimateGroupList,
  [types.MOBILE_ESTIMATE_DETAIL]: state => state.mobileEstimateDetail,
  [types.MOBILE_SERVICE_LIST]: state => state.mobileServiceList,
  [types.MOBILE_PROMISE]: state => state.mobilePromise,
  [types.MOBILE_PROMISE_LIST]: state => state.mobilePromiseList,
  [types.MOBILE_ESTIMATE_PREVIEW]: state => state.mobileEstimatePreview,
  [types.MOBILE_ESTIMATE_NEW_CNT]: state => state.mobileEstimateNewCnt,
  [types.MOBILE_PROMISE_NEW_CNT]: state => state.mobilePromiseNewCnt,
  [types.MOBILE_INSURANCE_LIST]: state => state.mobileInsuranceList,
  [types.MOBILE_CHAT_ESTIMATE_LIST]: state => state.mobileChatEstimateList,
  [types.MOBILE_APPLY_CNT_NEW]: state => state.mobileApplyNewCnt,
};

export default getters;
